import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const HFRLogo = ({
  height = 56,
  className,
  sx = {},
  onClick,
}) => (
  <Box
    component="img"
    src="/logo-full.png"
    alt="HFR Connect"
    className={className}
    onClick={onClick}
    sx={{
      height,
      width: 'auto',
      display: 'block',
      objectFit: 'contain',
      ...sx,
    }}
  />
);

HFRLogo.propTypes = {
  height: PropTypes.number,
  className: PropTypes.string,
  sx: PropTypes.object,
  onClick: PropTypes.func,
};

export default HFRLogo;
